import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { selectIsInProgress } from '../../spinner/ducks';
import { apiCallIds } from '../../messaging-dashboard/api';
import { fetchMessagingDataActions, selectMessagingData } from '../ducks';
import { EmailsDashboard } from '../components';
import Spin from 'antd/lib/spin';


const mapStateToProps = state => ({
    messagingData: selectMessagingData(state),
    isLoading: selectIsInProgress(state, apiCallIds.FETCH_MESSAGING_DATA),
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(
        {
            fetchMessagingData: fetchMessagingDataActions.request,
        },
        dispatch
    )
});


@connect(mapStateToProps, mapDispatchToProps)
export default class EmailsDashboardContainer extends Component {
    static propTypes = {
        actions: PropTypes.object,
    };


    constructor(props) {
        super(props);
        this.state = { messagingData: {} };
    }

    componentDidMount() {
        const { actions } = this.props;

        actions.fetchMessagingData()

    }


    render() {
        const { messagingData } = this.props;
        return (
            <div>
                {!messagingData ?
                    <Spin className="dasboard-spinner" spinning={!messagingData}>
                        <div className="dashboard-spinner-message">{"Prebieha výpočet dát pre dashboard"}</div>
                    </Spin> :
                    <EmailsDashboard data={messagingData}></EmailsDashboard>}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/features/messaging-dashboard/containers/EmailsDashboardContainer.js